var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_25",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C9.92189 21 8.15236 20.2823 6.69143 18.847C5.2305 17.4117 4.50003 15.6644 4.50003 13.6051C4.50003 12.6222 4.69459 11.6821 5.08371 10.7846C5.47281 9.88719 6.0103 9.09104 6.69618 8.39618L12 3.19235L17.3038 8.39618C17.9897 9.09104 18.5272 9.88733 18.9163 10.785C19.3054 11.6827 19.5 12.6233 19.5 13.6069C19.5 15.6677 18.7695 17.415 17.3086 18.849C15.8476 20.283 14.0781 21 12 21ZM6.00001 13.6096H18C18 12.8263 17.85 12.0793 17.55 11.3686C17.25 10.658 16.8167 10.0351 16.25 9.5L12 5.3L7.75001 9.5C7.18334 10.0351 6.75001 10.658 6.45001 11.3686C6.15001 12.0793 6.00001 12.8263 6.00001 13.6096Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.15f4b979135f988c3d0022fd2195d46a.svg";
export { ForwardRef as ReactComponent };